<template>
  <div class="signmember">
    <div class="signmember-content w1200">
      <h2 class="clum">
        <i class="icon">个人会员</i>
        <span class="more">更多</span>
      </h2>
      <div class="signmember-main">
        <p style="text-align: center;line-height: 376px;font-size: 18px;font-weight: bold;">数据中心搭建中</p>
        <ul class="rank-list">
          <!-- <li class="list-item">
             <div class="player-img">
               <img src="../../../../static/images/logo-big.png" alt="">
             </div>
             <div class="play-info">
               <div class="name">张敏敏</div>
               <div class="organ">机构:重庆XX跆拳道</div>
               <div class="rank-scroe">
                 <span>成绩积分:<i>1200</i></span>
                 <span>战绩:<i>23胜</i>/1负</span>
               </div>
             </div>
             <div class="win-rate">
               <span class="ratestr">99%胜率</span>
             </div>
          </li>
          <li class="list-item">
             <div class="player-img">
               <img src="../../../../static/images/logo-big.png" alt="">
             </div>
             <div class="play-info">
               <div class="name">张敏敏</div>
               <div class="organ">机构:重庆XX跆拳道</div>
               <div class="rank-scroe">
                 <span>成绩积分:<i>1200</i></span>
                 <span>战绩:<i>23胜</i>/1负</span>
               </div>
             </div>
             <div class="win-rate">
               <span class="ratestr">99%胜率</span>
             </div>
          </li>
          <li class="list-item">
             <div class="player-img">
               <img src="../../../../static/images/logo-big.png" alt="">
             </div>
             <div class="play-info">
               <div class="name">张敏敏</div>
               <div class="organ">机构:重庆XX跆拳道</div>
               <div class="rank-scroe">
                 <span>成绩积分:<i>1200</i></span>
                 <span>战绩:<i>23胜</i>/1负</span>
               </div>
             </div>
             <div class="win-rate">
               <span class="ratestr">99%胜率</span>
             </div>
          </li> -->

        </ul>
        <div class="score-rank">
          <ul class="score-list">
            <!-- <li class="score-item" v-for="(item,index) in rankList" :key='index'>
              <div class="play-img left">
                <img src="../../../../static/images/logo-big.png" alt="">
              </div>
              <div class="name left">{{item.name}}</div>
              <div class="rank-scroe left">
                <span>成绩积分:<i>{{item.scoreStr}}</i></span>
                <span>战绩:<i>{{item.win}}胜</i>/{{item.lose}}负</span>
              </div>
              <div class="rank-scroe left">胜率:<i>{{item.rankStr}}%</i></div>
              <div class="rank-index">{{item.rankIndex}}</div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  data () {
    return {
      rankList: [
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'},
        {name: '张二娃', scoreStr: '1200', win: '23', lose: '1', rankStr: '99', rankIndex: '4'}
      ]
    }
  },
  methods: {

  },
  mounted () {

  },
  created () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .signmember{
    width: 100%;
    background-color: #f3f3f3;
  }
  .signmember-content{
    padding: 20px 0px;
    background: #f3f3f3;
  }
  .signmember-content .clum{
    overflow:hidden;
    margin-bottom: 35px;
  }
  .signmember-content .clum .icon{
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../../static/images/sign_05.png);
    float:left;
    padding-left: 14px;
    font-style: normal;
  }
  .signmember-content .clum span{
    float:right;
    font-size:16px;
    color:#409EFF;
    line-height:30px;
    cursor:pointer;
  }
  .signmember-main{
    width: 100%;
    overflow: hidden;
  }
  .rank-list{
    width: 100%;
    overflow: hidden;
    width: 584px;
    float: left;
    height: 376px;
    display: none
  }
  .list-item{
    height:110px;
    width:100%;
    overflow: hidden;
    float: left;
    background: #fff;
    margin-bottom: 23px;

  }
  .list-item:hover{
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    transform: scale(1.02);
  }

  .list-item:last-child{
    margin-bottom: 0px;
  }
  .player-img{
    width: 117px;
    height:109px;
    float: left;
  }
  .player-img img{
    display: block;

  }
  .play-info{
    width:256px;
    float: left;
    margin-left: 20px;
    padding: 15px 0px 0px 0px;
  }
  .play-info .name{
    font-size: 18px;
    color:#333;
  }
  .play-info .organ{
    font-size: 14px;
    color:#7e7d7d;
    margin-top:12px;
  }
  .play-info .rank-scroe{
    font-size: 14px;
    color:#7e7d7d;
     margin-top: 14px;
  }
  .play-info .rank-scroe i{
    font-style: normal;
    color:#fe0000;
  }
  .play-info .rank-scroe span{
    float: left;
  }
  .play-info .rank-scroe span:nth-child(2){
    float: right;
    margin-right: 34px;
  }
  .win-rate{
    float: left;
    width: 190px;
    height: 100%;
    background: url(../../../../static/images/sign_01.png) 0px 0px no-repeat;
    background-size: 190px 111px;
    position: relative;
  }
  .win-rate .ratestr{
    font-size: 14px;
    color:#b80000;
    position: absolute;
    bottom:10px;
    right:58px;
  }
  .score-rank{
    float: right;
    width: -moz-calc(100% - 602px);
    width: -webkit-calc(100% - 602px);
    width: calc(100% - 602px);
    padding-left: 18px;
  }
  .score-list{
    width:100%;
  }
  .score-list .score-item{
    overflow: hidden;
    height:42px;
    margin-bottom: 5px;
    line-height: 40px;
    background: #fff;
  }
  .left{
    float:left;
  }

  .score-list .score-item:hover{
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    transform: scale(1.02);
  }
  .score-list .score-item .play-img{
    float: left;
    width:49px;
    height:43px;
  }
  .score-list .score-item .play-img img{
    display: block;
    width: 100%;
  }
  .score-list .score-item .name{
    font-size: 18px;
    margin-left: 15px;
  }
  .score-list .score-item .rank-scroe{
    margin-left: 47px;
  }
  .score-list .score-item .rank-scroe{
    font-size: 14px;
    color:#7e7d7d;
  }
  .score-list .score-item .rank-scroe i{
    font-style: normal;
    color:#fe0000;
  }
  .score-list .score-item .rank-scroe span{
    float: left;
  }
  .score-list .score-item .rank-scroe span:nth-child(2){

    margin-left: 34px;
  }
  .score-list .score-item .rank-index{
    float: right;
    width: 50px;
    height: 40px;
    background: url(../../../../static/images/sing_04.png) 0px 0px no-repeat;
    background-size: cover;
    font-size: 24px;
    line-height: 42px;
    color:#fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/SignMember/SignMember.vue